import { makeAutoObservable, runInAction } from "mobx";
import RmaPageStore from "../rma-page-store";
import { IEmailAttachment, IRmaActionEmailNotificationStore, IRmaReopenReuest } from "../../rma-types";

class RmaReopenActionStore implements IRmaActionEmailNotificationStore {
    private _model: Partial<IRmaReopenReuest> = {};
    private _isProcessing: boolean = false;

    constructor(private _rma: RmaPageStore, private _actionCallback: (data: IRmaReopenReuest) => void) {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    public get sendEmailNotification(): boolean { return this._model.send_email_notification ?? this.hasCustomerEmail(); }
    public get emailAdditionalContent(): string { return this._model.email_additional_content ?? ''; }
    public get emailAttachments(): IEmailAttachment[] { return this._model.email_attachment ?? []; }
    public get isProcessing(): boolean { return this._isProcessing; }

    public setSendEmailNotification(v: boolean) {
        this._model.send_email_notification = v;
    }

    public setEmailAdditionalContent(v: string) {
        this._model.email_additional_content = v;
    }

    public setEmailAttachments(v: IEmailAttachment[]) {
        this._model.email_attachment = v;
    }

    public addEmailAttachment(attachment: IEmailAttachment) {
        if (!this._model.email_attachment) {
            this._model.email_attachment = [];
        }
        this._model.email_attachment.push(attachment);
    }

    public removeEmailAttachment(attachment: IEmailAttachment) {
        if (!this._model.email_attachment) {
            return;
        }
        const index = this._model.email_attachment.indexOf(attachment);
        if (index > -1) {
            this._model.email_attachment.splice(index, 1);
        }
    }

    private requestModel(): IRmaReopenReuest {
		return {
            send_email_notification: this.sendEmailNotification,
            email_attachment: this.emailAttachments,
            email_additional_content: this.emailAdditionalContent,
        };
    }

    public async submitAction(closeCb?: () => void) {
        try {
            this._isProcessing = true;
            await this._actionCallback(this.requestModel());
            runInAction(() => {
                this._isProcessing = false;
                if (closeCb) {
                    closeCb();
                }
            });
        }
        catch (e) {
            runInAction(() => {
                this._isProcessing = false;
            });
        }    
    }

    public hasCustomerEmail(): boolean {
        return !!this._rma.orderStore?.customerEmail || !!this._rma.orderStore?.customer?.email;
    }
}

export default RmaReopenActionStore;